"use strict";

exports.__esModule = true;
exports["default"] = Blog;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Blog(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.13 25.244a2.434 2.434 0 0 1-2.437-2.433V2.499A2.437 2.437 0 0 1 4.13.063h23.559a2.436 2.436 0 0 1 2.436 2.436v20.309a2.437 2.437 0 0 1-2.436 2.44h-2.376v5.534a1.157 1.157 0 0 1-2.012.781l-6.315-6.315-12.856-.003z"
  }));
}